import {WidgetConfigurationItemObj} from './WidgetConfigurationItemObj';
import {WidgetExpand} from './WidgetExpand';
import {WidgetKeyPair} from './WidgetKeyPair';
import {WidgetSelect} from './WidgetSelect';
import {WidgetSort} from './WidgetSort';

export class WidgetConfigurationObj {
borderColor: string;
c: WidgetConfigurationItemObj[];
cm: string;
cmp: number | null;
cms: number | null;
cnx: string[];
cp: WidgetKeyPair[];
ct: string;
d: WidgetConfigurationItemObj[];
eda: boolean;
expPDF: boolean;
expXLS: boolean;
f: WidgetConfigurationItemObj[];
fdk: string;
ff: WidgetConfigurationItemObj[];
g: WidgetConfigurationItemObj[];
gatling: boolean;
gps: WidgetExpand[];
headerHeight: number | null;
hidden: boolean;
hme: boolean;
hsty: string;
i: WidgetConfigurationItemObj[];
icre: boolean;
idel: boolean;
iupd: boolean;
k: string;
massDel: boolean;
mefe: boolean | null;
mem: number;
muid: string;
noUserFilter: boolean;
nxstep: boolean;
pm: boolean;
pmd: boolean;
pmdex: boolean;
pmdexParams: string;
r: WidgetConfigurationItemObj[];
radius: number;
revert: boolean;
rowGps: WidgetExpand[];
rowHeight: number | null;
sa: boolean;
scenCode: string;
scenLbl: boolean;
scenOn: boolean;
scenUM: boolean;
scenX: boolean;
sel: WidgetSelect[];
shd: boolean;
showC: boolean;
showD: boolean;
showF: boolean;
showR: boolean;
shrd: boolean;
shs: boolean;
shsu: boolean;
sort: WidgetSort[];
stot: boolean;
targetPlace: string;
tv: number;
v: string;
vs: number | null;
vsp: string;
xlsC: boolean;
xlsNusc: boolean;
xlsSheet: string;
xlsU: boolean;
}

